import { useContext } from "react";
import CheckOutList from "../CheckOutList/CheckOutList";
import "./CheckOutExtra.css";
import Cover from "../../UI/Cover/Cover";
import Count from "../../UI/Count/Count";
import CheckOutButtons from "../../pages/CheckOut/CheckOutButtons";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { stateType } from "../../store";
import { cartItem } from "../../state_management/reducers/cart";
import {
  extra_service_ext,
  settings
} from "../../state_management/actionTypes";
import {
  calc_price_with_discount,
  currency,
  getExtras
} from "../../utilities/misc";
import { asyncResType } from "../../utilities/asyncFunc";
import { serviceItems } from "../../state_management/epics/settings";
import { LocaleContext, TotalWithCouponContext } from "../../AppProvider";

const CheckOutExtra = ({
  cart,
  settingRes
}: {
  cart: cartItem[];
  settingRes: asyncResType<serviceItems, settings>;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const [extraServices, setExtraServices] = useState<extra_service_ext[]>([]);

  /** Get a list of extra services */
  const cartCategoryList = useMemo(() => {
    const list = cart
      .map((service) => {
        return service.item.extra_services.map((item) => ({
          ...item,
          parent_id: service.id,
          price_with_discount: calc_price_with_discount(
            item.discount || 0,
            item.price
          ),
          extra: true
        }));
      })
      .flat() as extra_service_ext[];

    const List = getExtras(list);

    return List;
  }, [cart]);

  useEffect(() => {
    setExtraServices([...cartCategoryList]);
  }, [JSON.stringify(cartCategoryList)]);

  return (
    <div className="checkOutExtra_wrapper">
      <div className="flex checkout_content_wrapper">
        <div className="checkout_left">
          <div>
            <p className="med_text extra_intro_text">
              {t(
                "Based on your picks, here are some extra services you might want to consider"
              )}
            </p>
            <div className="checkout_content">
              {extraServices.map((service, n) => (
                <div key={n} className="checkout_extra_list_item box flex">
                  <div className="left">
                    <Cover className="checkOutExtra_img">
                      <img src={service.photo_path || ``} alt="" />
                    </Cover>
                  </div>
                  <div className="right flex1 fdCol">
                    <div className="med_text">{service.name}</div>
                    <div className="checkOut_extra_quantity_wrapper">
                      <div className="flex1">
                        <span className="fontBlue med_text">
                          {currency(
                            service.price_with_discount.toFixed(2),
                            locale
                          )}
                        </span>
                      </div>
                      <Count
                        extraService
                        fromZero
                        max={service.extra_max_quantity}
                        service={service}
                        allowPropagation
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <TotalMinAlert className="showSm" />
            <CheckOutButtons loading={settingRes.loading} />
          </div>
        </div>
        <div className="checkout_right">
          <CheckOutList loading={settingRes.loading} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer.cart,
  minimum_order: state.settingsReducer.minimum_order
});

const ConnectedCheckOutExtra = connect(mapStateToProps)(CheckOutExtra);

export default ConnectedCheckOutExtra;

export const TotalMinAlert = connect(mapStateToProps)(
  ({
    minimum_order,
    className
  }: {
    minimum_order: number | undefined;
    className?: string;
  }) => {
    const { t, locale } = useContext(LocaleContext);
    const [totalWithCoupon] = useContext(TotalWithCouponContext);

    return totalWithCoupon === null || totalWithCoupon === undefined ? (
      <></>
    ) : minimum_order !== undefined && minimum_order > totalWithCoupon ? (
      <div
        className={`checkout_min_alert_wrapper ${className ? className : ""}`}
      >
        <div className="checkout_min_alert_container">
          {t(
            "Please add {{amount}} more to place your order. Minimum total is {{amount}}",
            {
              "{{amount}}": [
                currency((minimum_order - totalWithCoupon).toFixed(2), locale),
                currency(minimum_order.toFixed(2), locale)
              ]
            }
          )}
        </div>
      </div>
    ) : (
      <></>
    );
  }
);
